module.exports = __webpack_public_path__ + "img/man.48ab22e6.png";